import { AppThunkAction } from '../reducers';

// Actions
import * as Actions from '../actions';

// Services
import * as service from '../../services/ProtocolConsumptions.Service';

// Models
import { ProtocolConsumption } from '../../models/Entities/Protocols/ProtocolConsumption';
import { ErrorType } from '../../models/HttpError';
import { ProtocolConsumptionTotal } from '../../models/Entities/Protocols/ProtocolConsumptionTotal';
import { NewProtocolConsumption } from '../../models/Entities/Protocols/NewProtocolConsumption';
import { Provider } from '../../models/Entities/Provider/Provider';
import { IPagedResult } from '../../models/HttpPagedResult';
import { IConsumptionsFilters } from '../../models/Filters/ConsumptionsFilters';

type KnownAction =
    | Actions.ProtocolConsumptions.ProtocolConsumptionGetAllByProtocolRequestAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionGetAllByProtocolSuccessAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionGetAllByProtocolFailureAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionGetByIdRequestAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionGetByIdSuccessAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionGetByIdFailureAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionCreateRequestAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionCreateSuccessAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionCreateFailureAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionUpdateRequestAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionUpdateSuccessAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionUpdateFailureAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionDeleteRequestAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionDeleteSuccessAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionDeleteFailureAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionGetTotalByStatusRequestAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionGetTotalByStatusSuccessAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionGetTotalByStatusFailureAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeStatusRequestAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeStatusSuccessAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeStatusFailureAction
    | Actions.ProtocolConsumptions.MarkConsumptionFollowUpRequestAction
    | Actions.ProtocolConsumptions.MarkConsumptionFollowUpSuccessAction
    | Actions.ProtocolConsumptions.MarkConsumptionFollowUpFailAction
    // get all protocol consumptions to settle
    | Actions.ProtocolConsumptions.ProtocolConsumptionGetAllToSettleRequestAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionGetAllToSettleSuccessAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionGetAllToSettleFailureAction
    // change consumption contract concept association
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeContractConceptRequestAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeContractConceptSuccessAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeContractConceptFailureAction
    // change producer
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeProducerRequestAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeProducerSuccessAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeProducerFailureAction
    // change provider
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeProviderRequestAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeProviderSuccessAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeProviderFailureAction
    // change amount 
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeAmountRequestAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeAmountSuccessAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeAmountFailureAction
    // change medical service
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeMedicalServiceRequestAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeMedicalServiceSuccessAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeMedicalServiceFailureAction
    // change visit type
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeTypeRequestAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeTypeSuccessAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeTypeFailureAction
    // change visit (stage)
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeVisitRequestAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeVisitSuccessAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionChangeVisitFailureAction
    // early discontinuation
    | Actions.ProtocolConsumptions.ProtocolConsumptionSetEarlyDiscontinuationRequestAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionSetEarlyDiscontinuationSuccessAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionSetEarlyDiscontinuationFailureAction
    // grouping
    | Actions.ProtocolConsumptions.ProtocolConsumptionSetGroupingRequestAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionSetGroupingSuccessAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionSetGroupingFailureAction
    // set as procedure
    | Actions.ProtocolConsumptions.ProtocolConsumptionSetProcedureRequestAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionSetProcedureSuccessAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionSetProcedureFailureAction
    // set as additional
    | Actions.ProtocolConsumptions.ProtocolConsumptionSetAdditionalRequestAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionSetAdditionalSuccessAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionSetAdditionalFailureAction
    // get consumptions by patient
    | Actions.ProtocolConsumptions.ProtocolConsumptionGetAllByPatientRequestAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionGetAllByPatientSuccessAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionGetAllByPatientFailureAction
    // get consumptions billed in the contract concept
    | Actions.ProtocolConsumptions.ProtocolConsumptionGetAllBilledInConceptRequestAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionGetAllBilledInConceptSuccessAction
    | Actions.ProtocolConsumptions.ProtocolConsumptionGetAllBilledInConceptFailureAction;

export const ActionCreators = {
    GetAllProtocolConsumptionsByProtocol: (protocolId: number, pageNumber: number, pageSize: number, filters: IConsumptionsFilters): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const appState = getState();
            let token: string = '';

            if (appState.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'PROTOCOLCONSUMPTION_GETALL_BYPROTOCOL_FAILURE',
                    protocolId: protocolId,
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = appState.oidc.user.access_token;
            };

            dispatch({
                type: 'PROTOCOLCONSUMPTION_GETALL_BYPROTOCOL_REQUEST',
                protocolId: protocolId
            });

            if (appState) {
                service.GetAllProtocolConsumptionByProtocol(
                    protocolId,
                    filters,
                    pageNumber,
                    pageSize,
                    token
                )
                    .then((list: IPagedResult<ProtocolConsumption[]>) => {
                        console.log('list', list);
                        dispatch({
                            type: 'PROTOCOLCONSUMPTION_GETALL_BYPROTOCOL_SUCCESS',
                            protocolId: protocolId,
                            paginationState: {
                                pageNumber: list.pageNumber,
                                pageSize: list.pageSize,
                                firstPage: list.firstPage,
                                lastPage: list.lastPage,
                                totalPages: list.totalPages,
                                totalRecords: list.totalRecords,
                                nextPage: list.nextPage,
                                previousPage: list.previousPage
                            },
                            filters,
                            consumptions: list.data,

                        });
                    })
                    .catch((error: ErrorType) => {
                        dispatch({
                            type: 'PROTOCOLCONSUMPTION_GETALL_BYPROTOCOL_FAILURE',
                            protocolId: protocolId,
                            error: error
                        });
                    });
            }
        },
    // change visit (stage)
    ChangeVisit:
        (
            protocolId: number,
            consumptionId: string,
            stageId: number
        ): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                let token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_CHANGE_VISIT_FAILURE',
                        protocolId: protocolId,
                        consumptionId: consumptionId,
                        stageId: stageId,
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                if (appState) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_CHANGE_VISIT_REQUEST',
                        protocolId: protocolId,
                        consumptionId: consumptionId,
                        stageId: stageId
                    });

                    service.SetConsumptionVisitStage(token, consumptionId, stageId)
                        .then((consumption: ProtocolConsumption) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_CHANGE_VISIT_SUCCESS',
                                protocolId: protocolId,
                                consumption: consumption
                            });
                        })
                        .catch((error: ErrorType) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_CHANGE_VISIT_FAILURE',
                                protocolId: protocolId,
                                consumptionId: consumptionId,
                                stageId: stageId,
                                error: error
                            });
                        });
                }
            },
    GetProtocolConsumptionToSettle:
        (protocolId: number): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                let token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_GETALL_TOSETTLE_FAILURE',
                        protocolId: protocolId,
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                if (appState) {
                    service.GetAllProtocolConsumptionByStatus(
                        protocolId,
                        6, // status to settle
                        token
                    )
                        .then((list: ProtocolConsumption[]) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_GETALL_TOSETTLE_SUCCESS',
                                protocolId: protocolId,
                                consumptions: list.filter(c => c.groupingId === null) // ensure status is to settle                       
                            });
                        })
                        .catch((error: ErrorType) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_GETALL_TOSETTLE_FAILURE',
                                protocolId: protocolId,
                                error: error
                            });
                        });
                }
            },
    GetProtocolConsumptionById:
        (
            protocolId: number,
            consumptionId: string
        ): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                let token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_GET_BYID_FAILURE',
                        consumptionId: consumptionId,
                        protocolId: 0,

                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                if (appState) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_GET_BYID_REQUEST',
                        protocolId: protocolId,
                        consumptionId: consumptionId
                    });

                    service.GetProtocolConsumptionById(token, consumptionId)
                        .then((consumption: ProtocolConsumption) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_GET_BYID_SUCCESS',
                                consumption: consumption
                            });
                        })
                        .catch((error: ErrorType) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_GET_BYID_FAILURE',
                                protocolId: protocolId,
                                consumptionId: consumptionId,
                                error: error
                            });
                        }
                        );
                }
            },
    CreateProtocolConsumption:
        (
            consumption: NewProtocolConsumption
        ): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                let token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_CREATE_FAILURE',
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                if (appState) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_CREATE_REQUEST',
                        consumption: consumption
                    });

                    service.CreateProtocolConsumption(token, consumption)
                        .then((consumption: ProtocolConsumption) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_CREATE_SUCCESS',
                                consumption: consumption
                            });
                        })
                        .catch((error: ErrorType) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_CREATE_FAILURE',
                                error: error
                            });
                        });
                }
            },
    UpdateProtocolConsumption:
        (
            consumption: ProtocolConsumption
        ): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                let token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_UPDATE_FAILURE',
                        protocolId: consumption.protocolId,
                        consumptionId: consumption.id,
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                if (appState) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_UPDATE_REQUEST',
                        consumption: consumption
                    });

                    service.UpdateProtocolConsumption(token, consumption)
                        .then((consumption: ProtocolConsumption) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_UPDATE_SUCCESS',
                                consumption: consumption
                            });
                        })
                        .catch((error: ErrorType) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_UPDATE_FAILURE',
                                protocolId: consumption.protocolId,
                                consumptionId: consumption.id,
                                error: error
                            });
                        });
                }
            },
    DeleteProtocolConsumption:
        (
            protocolId: number,
            consumptionId: string
        ): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                let token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_DELETE_FAILURE',
                        protocolId: protocolId,
                        consumptionId: consumptionId,
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                if (appState) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_DELETE_REQUEST',
                        protocolId: protocolId,
                        consumptionId: consumptionId
                    });

                    service.DeleteProtocolConsumption(token, consumptionId)
                        .then(() => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_DELETE_SUCCESS',
                                protocolId: protocolId,
                                consumptionId: consumptionId
                            });
                        })
                        .catch((error: ErrorType) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_DELETE_FAILURE',
                                protocolId: protocolId,
                                consumptionId: consumptionId,
                                error: error
                            });
                        });
                }
            },
    GetTotalsByStatus:
        (
            protocolId: number,
            status: number
        ): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                let token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_GET_TOTAL_BYSTATUS_FAILURE',
                        protocolId: protocolId,
                        status: status,
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                if (appState) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_GET_TOTAL_BYSTATUS_REQUEST',
                        status: status,
                        protocolId: protocolId
                    });

                    service.GetProtocolConsumptionTotals(protocolId, status, token)
                        .then((totals: ProtocolConsumptionTotal[]) => {
                            const auxTotals = totals?.map((total: ProtocolConsumptionTotal) => {
                                return {
                                    status: status,
                                    currencyCode: total.currencyCode,
                                    totalAmount: total.totalAmount
                                };
                            });

                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_GET_TOTAL_BYSTATUS_SUCCESS',
                                protocolId: protocolId,
                                status: status,
                                total: auxTotals
                            });
                        })
                        .catch((error: ErrorType) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_GET_TOTAL_BYSTATUS_FAILURE',
                                protocolId: protocolId,
                                status: status,
                                error: error
                            });
                        });
                }
            },
    MarkConsumptionFollowUp:
        (
            protocolId: number,
            consumptionId: string
        ): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                let token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'MARK_CONSUMPTION_FOLLOWUP_FAIL',
                        protocolId: protocolId,
                        consumptionId: consumptionId,
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                if (appState) {
                    dispatch({
                        type: 'MARK_CONSUMPTION_FOLLOWUP_REQUEST',
                        protocolId: protocolId,
                        consumptionId: consumptionId
                    });

                    service.MarkConsumptionFollowUp(token, consumptionId)
                        .then((consumption: ProtocolConsumption) => {
                            dispatch({
                                type: 'MARK_CONSUMPTION_FOLLOWUP_SUCCESS',
                                protocolId: protocolId,
                                consumptionId: consumptionId,
                                consumption: consumption
                            });
                        })
                        .catch((error: ErrorType) => {
                            dispatch({
                                type: 'MARK_CONSUMPTION_FOLLOWUP_FAIL',
                                protocolId: protocolId,
                                consumptionId: consumptionId,
                                error: error
                            });
                        });
                }
            },
    // Change status
    ChangeStatus:
        (
            protocolId: number,
            consumptionId: string,
            status: number,
            isForAll: boolean
        ): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                let token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_CHANGE_STATUS_FAILURE',
                        protocolId: protocolId,
                        status: status,
                        consumptionId: consumptionId,
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                if (appState) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_CHANGE_STATUS_REQUEST',
                        protocolId: protocolId,
                        consumptionId: consumptionId,
                        status: status,
                        isForAll: isForAll
                    });

                    service.ChangeProtocolConsumptionStatus(token, protocolId, consumptionId, status, isForAll)
                        .then(() => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_CHANGE_STATUS_SUCCESS',
                                protocolId: protocolId,
                                consumptionId: consumptionId,
                                status: status,
                                isForAll: isForAll
                            });
                        })
                        .catch((error: ErrorType) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_CHANGE_STATUS_FAILURE',
                                protocolId: protocolId,
                                status: status,
                                consumptionId: consumptionId,
                                error: error
                            });
                        });
                }
            },
    // change consumption contract concept association
    ChangeContractConcept:
        (
            protocolId: number,
            consumptionId: string,
            contractConceptId: number,
            changeAll: boolean
        ): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                let token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_CHANGE_CONTRACTCONCEPT_FAILURE',
                        protocolId: protocolId,
                        consumptionId: consumptionId,
                        contractConceptId: contractConceptId,
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                if (appState) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_CHANGE_CONTRACTCONCEPT_REQUEST',
                        protocolId: protocolId,
                        consumptionId: consumptionId,
                        contractConceptId: contractConceptId
                    });

                    service.SetConsumptionConcept(token, consumptionId, contractConceptId, changeAll)
                        .then((data: ProtocolConsumption[]) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_CHANGE_CONTRACTCONCEPT_SUCCESS',
                                protocolId: protocolId,
                                consumptionId: consumptionId,
                                updatedConsumptions: data,
                                contractConceptId: contractConceptId
                            });
                        })
                        .catch((error: ErrorType) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_CHANGE_CONTRACTCONCEPT_FAILURE',
                                protocolId: protocolId,
                                consumptionId: consumptionId,
                                contractConceptId: contractConceptId,
                                error: error
                            });
                        });
                }
            },
    // change producer
    ChangeProducer:
        (
            protocolId: number,
            consumptionId: string,
            producerId: string
        ): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                let token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_CHANGE_PRODUCER_FAILURE',
                        protocolId: protocolId,
                        consumptionId: consumptionId,
                        producerId: producerId,
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                if (appState) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_CHANGE_PRODUCER_REQUEST',
                        protocolId: protocolId,
                        consumptionId: consumptionId,
                        producerId: producerId
                    });

                    service.SetConsumptionProducer(token, consumptionId, producerId)
                        .then(() => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_CHANGE_PRODUCER_SUCCESS',
                                protocolId: protocolId,
                                consumptionId: consumptionId,
                                producerId: producerId,

                            });
                        })
                        .catch((error: ErrorType) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_CHANGE_PRODUCER_FAILURE',
                                protocolId: protocolId,
                                consumptionId: consumptionId,
                                producerId: producerId,
                                error: error
                            });
                        });
                }
            },
    // change provider
    ChangeProvider:
        (
            protocolId: number,
            consumptionId: string,
            provider: Provider
        ): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                let token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_CHANGE_PROVIDER_FAILURE',
                        protocolId: protocolId,
                        consumptionId: consumptionId,
                        providerId: provider.person.personIdentifier,
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                if (appState) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_CHANGE_PROVIDER_REQUEST',
                        protocolId: protocolId,
                        consumptionId: consumptionId,
                        providerId: provider.person.personIdentifier
                    });

                    service.SetConsumptionProvider(token, consumptionId, provider.id)
                        .then((consumption: ProtocolConsumption) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_CHANGE_PROVIDER_SUCCESS',
                                protocolId: protocolId,
                                consumption: consumption,
                            });
                        })
                        .catch((error: ErrorType) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_CHANGE_PROVIDER_FAILURE',
                                protocolId: protocolId,
                                consumptionId: consumptionId,
                                providerId: provider.person.personIdentifier,
                                error: error
                            });
                        });
                }
            },
    // change medical service
    ChangeMedicalService:
        (
            protocolId: number,
            consumptionId: string,
            medicalServiceId: number
        ): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                let token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_CHANGE_MEDICALSERVICE_FAILURE',
                        protocolId: protocolId,
                        consumptionId: consumptionId,
                        medicalServiceId: medicalServiceId,
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                if (appState) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_CHANGE_MEDICALSERVICE_REQUEST',
                        protocolId: protocolId,
                        consumptionId: consumptionId,
                        medicalServiceId: medicalServiceId
                    });

                    service.SetConsumptionMedicalService(token, consumptionId, medicalServiceId)
                        .then((consumption: ProtocolConsumption) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_CHANGE_MEDICALSERVICE_SUCCESS',
                                protocolId: protocolId,
                                consumption: consumption
                            });
                        })
                        .catch((error: ErrorType) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_CHANGE_MEDICALSERVICE_FAILURE',
                                protocolId: protocolId,
                                consumptionId: consumptionId,
                                medicalServiceId: medicalServiceId,
                                error: error
                            });
                        });
                }
            },

    // change amount
    ChangeAmount:
        (
            protocolId: number,
            consumptionId: string,
            amount: number,
            currencyCode: string
        ): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                let token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_CHANGE_AMOUNT_FAILURE',
                        protocolId: protocolId,
                        consumptionId: consumptionId,
                        amount: amount,
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                if (appState) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_CHANGE_AMOUNT_REQUEST',
                        protocolId: protocolId,
                        consumptionId: consumptionId,
                        amount: amount
                    });

                    service.SetConsumptionAmount(token, consumptionId, amount, currencyCode)
                        .then((consumption: ProtocolConsumption) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_CHANGE_AMOUNT_SUCCESS',
                                protocolId: protocolId,
                                consumption: consumption,
                            });
                        })
                        .catch((error: ErrorType) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_CHANGE_AMOUNT_FAILURE',
                                protocolId: protocolId,
                                consumptionId: consumptionId,
                                amount: amount,
                                error: error
                            });
                        });
                }
            },
    // change visit type 
    ChangeVisitType:
        (
            protocolId: number,
            consumptionId: string,
            visitTypeId: number
        ): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                let token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_CHANGE_TYPE_FAILURE',
                        protocolId: protocolId,
                        consumptionId: consumptionId,
                        visitType: visitTypeId,
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                if (appState) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_CHANGE_TYPE_REQUEST',
                        protocolId: protocolId,
                        consumptionId: consumptionId,
                        visitType: visitTypeId
                    });

                    service.SetConsumptionVisitType(token, consumptionId, visitTypeId)
                        .then((consumption: ProtocolConsumption) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_CHANGE_TYPE_SUCCESS',
                                protocolId: protocolId,
                                consumption: consumption
                            });
                        })
                        .catch((error: ErrorType) => {
                            dispatch({
                                type: 'PROTOCOLCONSUMPTION_CHANGE_TYPE_FAILURE',
                                protocolId: protocolId,
                                consumptionId: consumptionId,
                                visitType: visitTypeId,
                                error: error
                            });
                        });
                }
            }
    ,
    // set as procedure
    ChangeProcedure:
        (
            protocolId: number,
            consumptionId: string,
            isProcedure: boolean,
            changeAll: boolean
        ): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                let token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_SET_PROCEDURE_FAILURE',
                        protocolId,
                        consumptionId,
                        isProcedure,
                        changeAll,
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                dispatch({
                    type: 'PROTOCOLCONSUMPTION_SET_PROCEDURE_REQUEST',
                    protocolId,
                    consumptionId,
                    isProcedure,
                    changeAll
                });

                service.SetConsumptionAsProcedure(token, consumptionId, isProcedure, changeAll)
                    .then((consumption: ProtocolConsumption) => {
                        dispatch({
                            type: 'PROTOCOLCONSUMPTION_SET_PROCEDURE_SUCCESS',
                            protocolId,
                            consumption
                        });

                        // refresh list with current pagination and filters if available
                        const state = getState();
                        const proto = state.MedicalProtocols?.list?.find((p: any) => p.id === protocolId);
                        const pageNumber = proto?.consumptionPagintationState?.pageNumber ?? 1;
                        const pageSize = proto?.consumptionPagintationState?.pageSize ?? 100;
                        const currentFilters = proto?.consumptionsFilters ?? { SelectedConsumptions: [], SelectedProtocolPatients: [], SelectedContractConcepts: [], SelectedCurrencys: '', SelectedContractStages: [], SelectedPractitioners: [], SelectedStatus: [], SelectedProtocols: [], SelectedSettlements: [], SelectedDateRange: [undefined, undefined], FilterText: undefined };
                        ActionCreators.GetAllProtocolConsumptionsByProtocol(protocolId, pageNumber, pageSize, currentFilters as any)(dispatch as any, getState as any);
                    })
                    .catch((error: ErrorType) => {
                        dispatch({
                            type: 'PROTOCOLCONSUMPTION_SET_PROCEDURE_FAILURE',
                            protocolId,
                            consumptionId,
                            isProcedure,
                            changeAll,
                            error
                        });
                    });
            }
    ,
    // set as additional
    ChangeAdditional:
        (
            protocolId: number,
            consumptionId: string,
            isAdditional: boolean,
            changeAll: boolean
        ): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                let token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_SET_ADDITIONAL_FAILURE',
                        protocolId,
                        consumptionId,
                        isAdditional,
                        changeAll,
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                dispatch({
                    type: 'PROTOCOLCONSUMPTION_SET_ADDITIONAL_REQUEST',
                    protocolId,
                    consumptionId,
                    isAdditional,
                    changeAll
                });

                service.SetConsumptionAsAdditional(token, consumptionId, isAdditional, changeAll)
                    .then((consumption: ProtocolConsumption) => {
                        dispatch({
                            type: 'PROTOCOLCONSUMPTION_SET_ADDITIONAL_SUCCESS',
                            protocolId,
                            consumption
                        });

                        // refresh list with current pagination and filters if available
                        const state = getState();
                        const proto = state.MedicalProtocols?.list?.find((p: any) => p.id === protocolId);
                        const pageNumber = proto?.consumptionPagintationState?.pageNumber ?? 1;
                        const pageSize = proto?.consumptionPagintationState?.pageSize ?? 100;
                        const currentFilters = proto?.consumptionsFilters ?? { SelectedConsumptions: [], SelectedProtocolPatients: [], SelectedContractConcepts: [], SelectedCurrencys: '', SelectedContractStages: [], SelectedPractitioners: [], SelectedStatus: [], SelectedProtocols: [], SelectedSettlements: [], SelectedDateRange: [undefined, undefined], FilterText: undefined };
                        ActionCreators.GetAllProtocolConsumptionsByProtocol(protocolId, pageNumber, pageSize, currentFilters as any)(dispatch as any, getState as any);
                    })
                    .catch((error: ErrorType) => {
                        dispatch({
                            type: 'PROTOCOLCONSUMPTION_SET_ADDITIONAL_FAILURE',
                            protocolId,
                            consumptionId,
                            isAdditional,
                            changeAll,
                            error
                        });
                    });
            },
    GetAllProtocolConsumptionsByPatient: (
        protocolId: number,
        numberInProtocol: string
    ): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const appState = getState();
            let token: string = '';

            if (appState.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'PROTOCOLCONSUMPTION_GETALL_BYPATIENT_FAILURE',
                    protocolId,
                    numberInProtocol,
                    error: { ErrorCode: 401, ErrorMessage: 'Not authorized', Errors: [] }
                });
                return;
            } else {
                token = appState.oidc.user.access_token;
            }

            dispatch({
                type: 'PROTOCOLCONSUMPTION_GETALL_BYPATIENT_REQUEST',
                protocolId,
                numberInProtocol
            });

            service.GetConsumptionsByPatient(protocolId, numberInProtocol, token)
                .then((consumptions: ProtocolConsumption[]) => {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_GETALL_BYPATIENT_SUCCESS',
                        protocolId,
                        numberInProtocol,
                        consumptions
                    });
                })
                .catch((error: ErrorType) => {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_GETALL_BYPATIENT_FAILURE',
                        protocolId,
                        numberInProtocol,
                        error
                    });
                });
        },

    SetConsumptionEarlyDiscontinuation: (protocolId: number, consumptionId: string, isEarlyDiscontinuation: boolean): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const appState = getState();

            if (appState.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'PROTOCOLCONSUMPTION_SET_EARLYDISCONTINUATION_FAILURE',
                    protocolId,
                    consumptionId,
                    error: { ErrorCode: 401, ErrorMessage: 'Not authorized', Errors: [] }
                });
                return;
            }

            const token: string = appState.oidc.user.access_token;

            dispatch({
                type: 'PROTOCOLCONSUMPTION_SET_EARLYDISCONTINUATION_REQUEST',
                protocolId,
                consumptionId,
                isEarlyDiscontinuation
            });

            service.SetConsumptionEarlyDiscontinuation(token, consumptionId, isEarlyDiscontinuation)
                .then((consumption: ProtocolConsumption) => {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_SET_EARLYDISCONTINUATION_SUCCESS',
                        protocolId,
                        consumptionId,
                        consumption
                    });
                })
                .catch((error: ErrorType) => {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_SET_EARLYDISCONTINUATION_FAILURE',
                        protocolId,
                        consumptionId,
                        error
                    });
                });
        },

    SetConsumptionGrouping: (protocolId: number, consumptionId: string, group: boolean): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const appState = getState();

            if (appState.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'PROTOCOLCONSUMPTION_SET_GROUPING_FAILURE',
                    protocolId,
                    consumptionId,
                    error: { ErrorCode: 401, ErrorMessage: 'Not authorized', Errors: [] }
                });
                return;
            }

            const token: string = appState.oidc.user.access_token;

            dispatch({
                type: 'PROTOCOLCONSUMPTION_SET_GROUPING_REQUEST',
                protocolId,
                consumptionId,
                group
            });

            service.SetConsumptionGrouping(token, consumptionId, group)
                .then((consumption: ProtocolConsumption) => {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_SET_GROUPING_SUCCESS',
                        protocolId,
                        consumptionId,
                        consumption
                    });
                })
                .catch((error: ErrorType) => {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_SET_GROUPING_FAILURE',
                        protocolId,
                        consumptionId,
                        error
                    });
                });
        },

    GetConsumptionsBilledInConcept: (protocolId: number, consumptionId: string): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const appState = getState();
            let token: string = '';

            if (appState.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'PROTOCOLCONSUMPTION_GETALL_BILLEDINCONCEPT_FAILURE',
                    protocolId,
                    consumptionId,
                    error: { ErrorCode: 401, ErrorMessage: 'Not authorized', Errors: [] }
                });
                return;
            } else {
                token = appState.oidc.user.access_token;
            }

            dispatch({
                type: 'PROTOCOLCONSUMPTION_GETALL_BILLEDINCONCEPT_REQUEST',
                protocolId,
                consumptionId
            });

            service.GetConsumptionsBilledInConcept(token, consumptionId)
                .then((consumptions: ProtocolConsumption[]) => {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_GETALL_BILLEDINCONCEPT_SUCCESS',
                        protocolId,
                        consumptionId,
                        consumptions: consumptions ?? []
                    });
                })
                .catch((error: ErrorType) => {
                    dispatch({
                        type: 'PROTOCOLCONSUMPTION_GETALL_BILLEDINCONCEPT_FAILURE',
                        protocolId,
                        consumptionId,
                        error
                    });
                });
        },
};
